import { BoundToEdge, Components } from '../../../component-classes';
import { Item } from '../../item/item.class';

// Takes Item, not PanelItem like its siblings, because it also runs mid-constructor before `this` is a complete PanelItem
/**
 * Computes the default BoundToEdge for a brand-new PanelItem from its item's catalog placement.
 * @param item Item whose placement drives the binding
 * @returns BoundToEdge bitfield value
 */
export const getDefaultBoundToEdgeCfn = (item: Item): number => {
	const placementNorm = (item.placement ?? '').toLowerCase().trim();

	if ([Components.PLACEMENT_FRONT_AND_TOP, Components.PLACEMENT_TOP_ONLY].indexOf(placementNorm) > -1) return BoundToEdge.Top;
	if (placementNorm === Components.PLACEMENT_BOTTOM_ONLY) return BoundToEdge.Bottom;

	return BoundToEdge.No;
};
